import { render } from "./DistributionMain.vue?vue&type=template&id=c279af0c"
import script from "./DistributionMain.vue?vue&type=script&lang=js"
export * from "./DistributionMain.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__